import React from 'react';
import { InventoryItem } from 'lib/context';
import { toNumber } from 'lodash';
import { useTranslation } from 'react-i18next';
import { StatusBadge } from 'react-covideo-common';
import { useTheme } from 'styled-components/macro';

type Props = {
  inventoryItem: InventoryItem;
};

export const TableFieldVideosRecorded = ({ inventoryItem }: Props) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const videosRecorded = inventoryItem.videosRecorded
    ? toNumber(inventoryItem.videosRecorded)
    : 0;

  return (
    <>
      <StatusBadge
        size='small'
        variant='gray'
        text={
          !!videosRecorded
            ? t('{{count}} video', { count: videosRecorded })
            : t('No Videos')
        }
        extendStyles={{
          container: {
            ...(!videosRecorded && { background: colors.white[100] }),
          },
          text: {
            ...(!videosRecorded && { color: colors.neutral[80] }),
          },
        }}
      />
    </>
  );
};
